import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, H4 } from '@bigcommerce/big-design';

import { thresholdUpdate } from '../../../redux/actions/thresholds';

const UpdateThresholdModal = ({ payload, locationId, showUpdateThresholdModal, setShowUpdateThresholdModal, threshold, thresholdName, updateThreshold }) => {
  const [lowInventory, setLowInventory] = useState(null);
  const [criticalInventory, setCriticalInventory] = useState(null);
  const [targetInventory, setTargetInventory] = useState(null);

  const clearAndClose = () => {
    setLowInventory(null);
    setCriticalInventory(null);
    setTargetInventory(null);
    setShowUpdateThresholdModal(false)
  }

  const update = () => {
    let thresholdValues = { lowInventory: lowInventory, criticalInventory: criticalInventory, targetInventory: targetInventory };
    updateThreshold(payload, locationId, threshold, thresholdValues);
    clearAndClose();
  }

  const validateQuantity = (event, setField) => {
    let value = event.target.value;
    setField(value.replace(/[^\d.-]+/g, '') || 0.0);
  }

  const validateValue = (event, setField) => {
    let value = event.target.value;
    setField(value);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => clearAndClose(),
        },
        { text: 'Update Thresholds', onClick: () => update() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Update Thresholds"
      isOpen={showUpdateThresholdModal}
      onClose={() => clearAndClose()}
    >
      <H3>{thresholdName}</H3>
      <H4>Curent Target Inventory</H4>
      {threshold?.target_inventory}

      <H4>Curent Low Inventory</H4>
      {threshold?.low_inventory}

      <H4>Curent Critical Inventory</H4>
      {threshold?.critical_inventory}

      <hr/>

      <Input label="Update Target Inventory" placeholder={threshold?.target_inventory} id="update_target_inventory" type="text" value={targetInventory} onChange={(e) => validateValue(e, setTargetInventory)} />
      <Input label="Update Low Inventory" placeholder={threshold?.low_inventory} id="update_low_inventory" min="0" type="number" value={lowInventory} onChange={(e) => validateQuantity(e, setLowInventory)} />
      <Input label="Update Critical Inventory" placeholder={threshold?.critical_inventory} id="update_minimum_quantity" min="0" type="number" value={criticalInventory} onChange={(e) => validateQuantity(e, setCriticalInventory)} />
    </Modal>
  )
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = (dispatch) => ({
  updateThreshold: (payload, locationId, threshold, thresholdValues) => dispatch(thresholdUpdate(payload, locationId, threshold, thresholdValues)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateThresholdModal);
